import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgxsModule } from "@ngxs/store";
import { InputModule } from "@vattenfall/ui";

import { ElectricalProductsFilterComponent } from "./electrical-products-filter.component";
import { ElectricalProductsFilterState } from "./electrical-products-filter.state";

@NgModule({
  declarations: [ElectricalProductsFilterComponent],
  imports: [CommonModule, FormsModule, NgxsModule.forFeature([ElectricalProductsFilterState]), InputModule],
  bootstrap: [ElectricalProductsFilterComponent],
})
export class ElectricalProductsFilterModule {}
